module.exports = __webpack_public_path__ + "static/img/btn_nojuanzeng_nor.66e3cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_nojuanzeng_nor.png
// module id = ILYt
// module chunks = 1